import { useState, Fragment, lazy } from "react";
import { Row, Col, Drawer } from "antd";
import { CSSTransition } from "react-transition-group";
import { withTranslation } from "react-i18next";
import { MenuOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive'

import * as S from "./styles";

const SvgIcon = lazy(() => import("../../common/SvgIcon"));
//const Button = lazy(() => import("../../common/Button"));

const Header = ({ t }) => {
  const [isNavVisible] = useState(false);
  const [isSmallScreen] = useState(false);
  const [visible, setVisibility] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  //const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  //const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id) => {
      const element = document.getElementById(id);
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };
    return (
      <Fragment>
        <br></br>
        <S.CustomNavLinkSmall style={ !visible ? { color: "#ffffff" } : { color: "#OOO" } } onClick={() => scrollTo("about")}>
          <S.Span>{t("A propos")}</S.Span>
        </S.CustomNavLinkSmall>
        <S.CustomNavLinkSmall  style={ !visible ? { color: "#ffffff" } : { color: "#OOO" } }  onClick={() => scrollTo("product")}>
          <S.Span>{t("Collections")}</S.Span>
        </S.CustomNavLinkSmall>
        {/*<S.CustomNavLinkSmall
          style={ !visible ? { color: "#ffffff", width: "180px" } : { color: "#OOO", width: "180px" } }
          onClick={() => scrollTo("contact")}
        >
          <S.Span>
            <Button>{t("Contact")}</Button>
          </S.Span>
        </S.CustomNavLinkSmall>*/}
      </Fragment>
    );
  };

  return (
    <S.Header>
      <S.Container>
        <Row type="flex" justify="space-between" gutter={20}>
          <S.LogoContainer to="/" aria-label="homepage">
            { isDesktopOrLaptop && (
              <>
                <SvgIcon src="logo.png" height="80px"/>
                <S.CustomNavLinkSmall style={{ color: "#ffffff", paddingTop: "0.5rem", fontSize: "2rem", lineHeight: "85%" }}>
                  <S.Span><span style={{letterSpacing: "11px" }}>{t("ANIOMALY")}</span></S.Span><br></br>
                  <span style={{ fontWeight: 1, color: "grey", letterSpacing: "11px" }}>APPAREL</span>
                </S.CustomNavLinkSmall>
              </>  
              )
            }
            { isTabletOrMobile && (
              <>
                <SvgIcon src="logo.png" height="80px" style={{ height: "80px" }} />
                <S.CustomNavLinkSmall style={{ color: "#ffffff", paddingTop: "0.1rem", fontSize: "1rem", lineHeight: "85%" }}>
                  <S.Span><span style={{ letterSpacing: "5px" }}>{t("ANIOMALY")}</span></S.Span><br></br>
                  <span style={{ fontWeight: 1, color: "grey", letterSpacing: "5px" }}>APPAREL</span>
                </S.CustomNavLinkSmall>
              </>
              )
            }
          </S.LogoContainer>
          <S.NotHidden>
            <MenuItem />
          </S.NotHidden>
          <S.Burger onClick={showDrawer}>
            <MenuOutlined style={{ fontSize: '22px', color: '#fff' }} />
          </S.Burger>
        </Row>
        <CSSTransition
          in={!isSmallScreen || isNavVisible}
          timeout={350}
          classNames="NavAnimation"
          unmountOnExit
        >
          <Drawer closable={false} visible={visible} onClose={onClose}>
            <Col style={{ marginBottom: "2.5rem"}}>
              <S.Label onClick={onClose}>
                <Col span={12}>
                  <S.Menu>Menu</S.Menu>
                </Col>
                <Col span={12}>
                  <MenuOutlined style={{ fontSize: '22px', color: '#000', paddingRight: '10px' }} />
                </Col>
              </S.Label>
            </Col>
            <MenuItem />
          </Drawer>
        </CSSTransition>
      </S.Container>
    </S.Header>
  );
};

export default withTranslation()(Header);
